import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerAltriDocumentiVersamentoModalComponent } from './worker-altri-documenti-versamento-modal';

export const WorkerAltriDocumentiVersamentoModalModule: string = ng
    .module('worker-altri-documenti-versamento-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerAltriDocumentiVersamentoModalComponent', WorkerAltriDocumentiVersamentoModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-altri-documenti-versamento-modal/worker-altri-documenti-versamento-modal.module.ts